/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

export default [[["північ","п","ранку","дня","вечора","ночі"],["опівночі","пополудні","ранку","дня","вечора","ночі"],u],[["північ","полудень","ранок","день","вечір","ніч"],u,u],["00:00","12:00",["04:00","12:00"],["12:00","18:00"],["18:00","24:00"],["00:00","04:00"]]];
